import Info from '@components/Info'
import Button from '@components/UI/Button'
import Heading from '@components/UI/Typography/Heading'
import Paragraph from '@components/UI/Typography/Paragraph'
import useUtmTags, { Utm } from '@hooks/useUtmTags';
import css from '@utils/css'

import React, { useEffect, useState } from 'react'

const Banner = () => {
    const [isProfitCountry, setIsProfitCountry] = useState()

    useEffect(() => {
        (async () => {
            const countryData = await (await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support/country`)).json()
            setIsProfitCountry(countryData && countryData.userCountryInfo.code && countryData.profitCountries.includes(countryData.userCountryInfo.code))
        })()
    }, [])

    return (
        <>
            <div
                className='help-center__banner gap-x-8'
            >
                <Info
                    gap={ 1 }
                >
                    <Heading
                        tag='h3'
                        color='white'
                    >
                        Need more information or help?
                    </Heading>

                    <Paragraph
                        tap='p'
                        size='lg'
                        color='white'
                    >
                        Send us a message and we’ll respond promptly.
                    </Paragraph>
                </Info>
                <div className={ css(
                    'flex flex-col gap-4 w-full justify-center',
                    '768:(flex-row w-auto)',
                    '1024:(justify-end)'
                ) }
                >
                    <Button
                        tag='a'
                        type='link'
                        href={ useUtmTags(
                            '/contact',
                            {
                                utm_campaign: Utm.CAMPAIGN.BANNER,
                                utm_term: 'Contact Us'
                            }) }
                        variant='secondary'
                        className={ css(
                            'button_md whitespace-nowrap',
                            '768:(order-2)',
                            '768:max-1024:!px-[61px]'
                        ) }
                    >
                        Contact Us
                    </Button>
                    { isProfitCountry &&
                        <Button
                            tag='a'
                            type='link'
                            href='/feedback'
                            variant='primary'
                            className='button_md whitespace-nowrap'
                        >
                            Suggest a Feature
                        </Button>
                    }
                </div>
            </div>
        </>
    )
}


export default Banner
